import intlTelInput from 'intl-tel-input';
import intlTelInputUtils from 'intl-tel-input/build/js/utils';

document.addEventListener('DOMContentLoaded', function () {
    const phones = document.getElementsByClassName('js-intl-phone')
    Array.from(phones).forEach((phone) => {
        const iti = intlTelInput(phone, {
            utilsScript: intlTelInputUtils,
            preferredCountries: ['ro', 'de'],
            nationalMode: false,
            customContainer: phone.classList.contains('is-invalid') ? 'is-invalid' : null
        });

        const handleChange = function() {
            //this.value = iti.getNumber()
        };

        phone.addEventListener('change', handleChange);
        phone.addEventListener('keyup', handleChange);
    })

})
